// src/services/PromptsApi.js
import { getApiBaseUrl, getApiHeaders, API_TIMEOUTS, fetchWithTimeout } from './apiConfig';

const API_BASE_URL = getApiBaseUrl();

export const promptsApi = {
  // Get all prompts
  getPrompts: async () => {
    const response = await fetchWithTimeout(`${API_BASE_URL}/prompts`, {
      method: 'GET',
      headers: getApiHeaders()
    }, API_TIMEOUTS.DEFAULT, 'api', 'high');
    
    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }
    
    const data = await response.json();
    return Array.isArray(data) ? data : [];
  },

  // Create a new prompt
  createPrompt: async (promptData) => {
    const response = await fetchWithTimeout(`${API_BASE_URL}/prompts`, {
      method: 'POST',
      headers: getApiHeaders(),
      body: JSON.stringify(promptData)
    }, API_TIMEOUTS.DEFAULT, 'api', 'normal');
    
    if (!response.ok) {
      const errorText = await response.text();
      throw new Error(`HTTP error! Status: ${response.status}, Message: ${errorText}`);
    }
    
    return response.json();
  },

  // Update an existing prompt
  updatePrompt: async (promptData) => {
    const response = await fetchWithTimeout(`${API_BASE_URL}/prompts/${promptData.id}`, {
      method: 'PUT',
      headers: getApiHeaders(),
      body: JSON.stringify(promptData)
    }, API_TIMEOUTS.DEFAULT, 'api', 'normal');
    
    if (!response.ok) {
      const errorText = await response.text();
      throw new Error(`HTTP error! Status: ${response.status}, Message: ${errorText}`);
    }
    
    return response.json();
  },

  // Delete a prompt
  deletePrompt: async (promptId) => {
    const response = await fetchWithTimeout(`${API_BASE_URL}/prompts/${promptId}`, {
      method: 'DELETE',
      headers: getApiHeaders()
    }, API_TIMEOUTS.DEFAULT, 'api', 'normal');
    
    if (!response.ok) {
      const errorText = await response.text();
      throw new Error(`HTTP error! Status: ${response.status}, Message: ${errorText}`);
    }
    
    return true;
  },

  // Get prompt by ID
  getPromptById: async (promptId) => {
    const response = await fetchWithTimeout(`${API_BASE_URL}/prompts/${promptId}`, {
      method: 'GET',
      headers: getApiHeaders()
    }, API_TIMEOUTS.DEFAULT, 'api', 'high');
    
    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }
    
    return response.json();
  }
};